<template>
    <div class="modal-full">
        <div class="modal-header">
            <close-icon v-on:click="closeView"></close-icon>
            <h1>Edit Package</h1>
        </div>

        <div class="modal-body no-pad" v-if="package">
            <div class="flex h-full">
                <div class="account-sidebar h-full">
                    <div class="mb-3">
                        <label>ID</label>
                        <p>{{ package.id }}</p>
                    </div>
                </div>

                <div class="account-body">
                    <form class="profile-form">
                        <div class="form-field">
                            <label>Name</label>
                            <input type="text" v-model="package.name">
                        </div>

                        <div class="form-field">
                            <label>Cost (Inc. Tax)</label>
                            <input type="number" step="0.01" min="0" v-model="package.gross_cost">
                        </div>

                        <div class="form-field">
                            <label>Cost</label>
                            <input type="number" step="0.01" min="0" v-model="package.cost">
                        </div>

                        <div class="form-field">
                            <label>Account Groups</label>
                            <picker-selector placeholder="Select Account Groups"
                                             :value="accountGroups"
                                             input-name="packages[]"
                                             @input="addAccountGroup"
                                             route="accountGroups.select">
                            </picker-selector>
                        </div>

                        <div class="form-field">
                            <label>Active</label>
                            <CheckBox v-model="package.active"/>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <div class="flex">
                <div class="right text-right">
                    <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                    <button class="btn-primary" type="button" @click="saveForm">Save</button>
                </div>
            </div>
        </div>
        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>

<script>
export default {
    name: 'PackageView',
    props: {
        //
    },
    components: {
        //
    },
    data() {
        return {
            package: null,
            accountGroups: []
        }
    },
    computed: {
        //
    },
    mounted() {
        this.loadData()

        this.setMetaTitle('Edit Package | JournoLink Control')
    },
    beforeDestroy() {
        //
    },
    beforeRouteUpdate(to, from, next) {
        this.$route.params.id = to.params.id
        this.loadData()
        next()
    },
    methods: {
        loadData() {
            axios.get(route('packages.show', this.$route.params.id))
                .then(response => {
                    this.package = response.data.package
                    this.accountGroups = response.data.account_groups
                    this.setMetaTitle('Edit Package | JournoLink Control')
                })
                .catch(e => {
                    console.error({e})
                })
        },
        addAccountGroup(ids) {
            this.accountGroups = ids
        },
        /**
         * Emit the close event to the parent
         *
         * @return {void}
         */
        closeView() {
            this.$root.goBack()
        },
        /**
         * Save Package
         */
        saveForm() {
            axios.put(route('packages.update', this.$route.params.id), {
                'package': this.package,
                'account_groups': this.accountGroups
            }).then(response => {
                this.package = response.data.package
                this.accountGroups = response.data.account_groups
                this.$bus.$emit('alert.success', 'Package has been saved')
            }).catch(e => {
                console.error({e})
            })
        },
        /**
         * Handle an [Escape] keypress
         *
         * @return {void}
         */
        onEscapeKeypress() {
            this.closeView()
        },
    },
    watch: {
        'package.cost': function (value) {
            value = Number(value)
            if (_.isNumber(value)) {
                this.package.gross_cost = (value * (1 + this.package.tax_rate)).toFixed(2)
            }
        },
        'package.gross_cost': function (value) {
            value = Number(value)
            if (_.isNumber(value)) {
                this.package.cost = (value / (1 + this.package.tax_rate)).toFixed(2)
            }
        }
    },
}
</script>

<style lang="less" scoped>
.account-sidebar {
    padding: 15px;
    width: 350px;
    font-size: 0.9rem;
    background: #f6f6f6;

    label {
        font-weight: bold;
        font-size: 0.8em;
        color: #999999;
    }

    p {
        margin-bottom: 0.5em;
    }
}

.account-activity {
    width: 250px;
    font-size: 0.9rem;
    padding: 15px;
}

.hidden-input {
    input {
        display: none;
        width: 100%;
    }

    .show {
        display: inline-block;
    }

    .hide {
        display: none;
    }

    .edit-field-link {
        text-decoration-line: underline;
        text-decoration-style: solid;
        color: #222222;
        word-wrap: break-word;
    }
}

.profile-form {
    .section-title {
        margin-top: 20px;
    }

    .form-title {
        margin-bottom: 20px;
    }
}
</style>
